import React from "react";
import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";

/** Acción principal del selector de un reporte: botón relleno del color primario, a todo el ancho. */
export const BotonGenerar = ({ onClick, children = "Generar Reporte" }) => (
  <Button
    variant="contained"
    color="primary"
    size="large"
    fullWidth
    startIcon={<FontAwesomeIcon icon={faPrint} />}
    onClick={onClick}
  >
    {children}
  </Button>
);
